import React from 'react';
import './MexicanFlagBanner.css';
import MexicoFlag from '../images/mexico-flag.png';

const MexicanFlagBanner = () => {
  return (
    <div className="mexican-flag-banner">
      <div className="flag-container">
        <img src={MexicoFlag} alt="Bandera de México" className="mexico-flag-svg" />
      </div>
      <div className="military-text">
        <h2>EJÉRCITO, FUERZA AÉREA, GUARDIA NACIONAL</h2>
        <p>LA GRAN FUERZA DE MÉXICO</p>
      </div>
    </div>
  );
};

export default MexicanFlagBanner;
